export default __webpack_public_path__ + "static/media/apple.37c32ac1.svg";